<template>
  <div>
    <b-row class="mx-0 mt-5 customers-weekly-row">
      <!-- Start list view headers -->
      <b-col
        md="12"
        xl="12"
        lg="12"
        class="d-flex pl-0 pr-2 py-2 mx-0 handover-card-column justify-space-evenly"
      >
        <b-col cols="4" class="">
          <p
            class="primary--text font-family-medium"
            style="padding-left: 2px;"
          >
            Customer name
          </p>
        </b-col>
        <b-col cols="6" class="">
          <p class="primary--text font-family-medium header-2">
            Task
          </p>
        </b-col>
        <b-col cols="2" class="date-header d-flex">
          <p class="primary--text font-family-medium">
            Date
          </p>
        </b-col>
      </b-col>
      <!-- End list view headers -->

      <!-- Start skeleton loader -->
      <b-row
        v-if="isLoading && !weeklyNotesList.length"
        class="mx-0 border-primary-lighter weekly-list-wrapper w-100"
      >
        <b-col
          md="12"
          xl="12"
          lg="12"
          class="flex-column pl-2 pr-0 py-2 mx-0 handover-card-column"
        >
          <b-col
            v-for="(item, index) in 4"
            :key="index"
            md="12"
            xl="12"
            lg="12"
            class="px-2 py-2 handover-card-column"
          >
            <b-card no-body>
              <b-card-body class="px-4 py-2 d-flex align-items-center">
                <b-col md="3" class="p-0 d-flex align-items-center">
                  <b-skeleton
                    type="avatar"
                    width="4.4rem"
                    height="4.4rem"
                  ></b-skeleton>
                  <b-skeleton class="ml-5" width="50%"></b-skeleton>
                </b-col>
                <b-col md="6" class="pl-0 position-relative">
                  <b-skeleton width="50%"></b-skeleton>
                  <b-skeleton width="75%"></b-skeleton>
                  <b-skeleton width="85%"></b-skeleton>
                </b-col>
                <b-col md="2">
                  <b-skeleton width="50%"></b-skeleton>
                </b-col>
                <b-col md="1" class="d-flex justify-content-end">
                  <b-skeleton width="20%" class="ml-3"></b-skeleton>
                </b-col>
              </b-card-body>
            </b-card>
          </b-col>
        </b-col>
      </b-row>
      <!-- End skeleton loader -->

      <!-- List view start -->
      <div
        v-if="weeklyNotesList.length > 0"
        class="mx-0 weekly-list-wrapper w-100 card-holding-container"
      >
        <b-row no-gutters>
          <b-col
            v-for="item in weeklyNotesList"
            :key="item.id"
            md="12"
            xl="12"
            lg="12"
            class="handover-card-column"
          >
            <b-card
              @click="navigate(item)"
              @mouseenter="showCardHover(item.id)"
              @mouseleave="undoCardHover(item.id)"
              no-body
            >
              <b-card-body class="">
                <b-row :style="{ flex: 1 }">
                  <b-col md="4" class="d-flex align-items-center">
                    <div
                      class="avatarClick"
                      @click="navigateToContact(item.participent.id)"
                    >
                      <b-avatar
                        size="4.4rem"
                        :src="item.participent.avatarThumbnail"
                        v-if="item.participent.avatarThumbnail"
                      ></b-avatar>
                      <b-avatar
                        size="4.4rem"
                        v-else
                        class="bg--primary weekly-tasks-avatar"
                        :text="item.customerInitials"
                      ></b-avatar>
                    </div>
                    <h6
                      class="font-sm primary--text font-family-medium ml-4 mt-1"
                    >
                      {{
                        `${item.participent.firstName} ${item.participent.lastName}`
                      }}
                    </h6>
                  </b-col>
                  <b-col md="6" class="">
                    <h6 class="font-sm primary--text font-family-medium">
                      {{ item.title }}
                    </h6>
                    <h6
                      class="font-sm secondary--text font-weight-normal html-text reduce-whitespace-2 pre-line"
                    >
                      {{
                        item.finalNotes.length > 50
                          ? `${item.finalNotes.substring(0, 50)}...`
                          : item.finalNotes
                      }}
                    </h6>
                  </b-col>
                  <b-col cols="2" class=" date">
                    <h6 class="font-sm primary--text font-family-regular">
                      {{
                        item.modified ? getFormattedDate(item.modified) : "N/A"
                      }}
                    </h6>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>
          <!-- <b-col
          v-if="weeklyNotesList.length > 5"
          class="d-flex justify-content-center mt-4 mb-4 py-5"
        >
          <b-button class="btn-danger btn-pill px-5 py-3">View More</b-button>
        </b-col> -->
        </b-row>
        <infinite-loading @infinite="filterNotesByCustomers">
          <div slot="no-more">No more tasks to load</div>
          <div slot="no-results">No more tasks to load</div>
        </infinite-loading>
      </div>
      <!-- List view end -->
    </b-row>
    <b-row
      class="mt-5 d-flex justify-content-center"
      v-if="weeklyNotesList.length === 0 && !isLoading"
    >
      <div
        class="no-assigned-msg pr-5 mt-4 pt-5 pb-5 pl-2 d-flex flex-column justify-content-center align-items-center"
      >
        <h4 class="font-md primary--text font-family-medium">
          No notes found.
        </h4>
      </div>
    </b-row>
    <b-avatar
      size="4.8rem"
      button
      @click="
        $router.push({
          name: 'AddWeeklyTaskCustomer',
          params: {
            name: customerFullName
          }
        })
      "
      v-if="role === 'assistant'"
      class="floating-action-btn btn-danger mb-5 position-fixed cursor-pointer"
    >
      <img src="@/assets/icons/floating_plus.svg" alt="" />
    </b-avatar>
  </div>
</template>

<script>
import { getNotesListByCustomers } from "@/apis/common";
import moment from "moment";
import { getProfile } from "@/apis/auth";
export default {
  data() {
    return {
      name: "CustomersWeekly",
      weeklyNotesList: [],
      isLoading: true,
      isSelf: null,
      role: "",
      expandHover: false,
      activeExpandHoverId: "",
      inactiveExpandHoverId: "",
      showInactiveExpandHover: true,
      currPage: 1,
      pageSize: 5
    };
  },
  props: ["customerFullName"],
  methods: {
    getFormattedDate(date) {
      return moment(date).format("MM/DD/YYYY");
    },
    showCardHover(id) {
      this.activeExpandHoverId = id;
      this.expandHover = true;
      this.showInactiveExpandHover = true;
    },
    undoCardHover(id) {
      this.inactiveExpandHoverId = id;
      this.expandHover = false;
    },
    navigate(item) {
      this.$router.push({
        name: "ViewWeeklyTaskCustomer",
        params: {
          profileId: this.$route.params.profileId,
          assistantId: item.organizer.id,
          notesId: item.id,
          name: this.customerFullName
        }
      });
    },
    navigateToContact(id) {
      this.$router.push({
        name: "CustomerDetails",
        params: {
          profileId: id
        },
        query: { tab: 2 }
      });
    },
    filterNotesByCustomers($state) {
      this.isLoading = true;
      getNotesListByCustomers(
        this.$route.params.profileId,
        this.pageSize,
        this.pageSize * (this.currPage - 1)
      )
        .then(res => {
          if (res.data.results.length) {
            let notesList = [...res.data.results].map(item => {
              item.strippedNotes = item.notes.replace(
                /<\/?(?!img)\w*\b[^>]*>/gi,
                ""
              );
              item.finalNotes = item.strippedNotes.replace(
                /<img[^>]*>/g,
                "\nImage added\n"
              );
              item.customerFullName = `${item.participent.firstName} ${item.participent.lastName}`;
              item.customerInitials = item.customerFullName
                .match(/\b(\w)/g)
                .join("");
              return item;
            });
            this.weeklyNotesList.push(...notesList); // pushing new loaded content in the existing notes list
            this.currPage += 1;
            $state.loaded();
          } else {
            // when there is no data on next load request
            $state.complete();
            this.isLoading = false;
          }
        })
        .catch(err => {
          console.log(err.response);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  created() {
    getProfile()
      .then(res => {
        const { defaultProfile, role } = res.data;
        this.role = role;
        this.assistantProfileId = defaultProfile.id;
        this.filterNotesByCustomers();
      })
      .catch(err => {
        console.log(err.response);
      });
  }
};
</script>

<style scoped lang="scss">
.floating-action-btn {
  right: 3rem;
  z-index: 2;
  bottom: 0;
}
.grid-list-action-icons {
  margin-top: -1.5rem;
  top: 40%;
  right: 1rem;
}
.header-2 {
  left: 4%;
}
.view-header h6 {
  left: 8%;
}
.card-expand-header img {
  right: 10%;
}
.customers-weekly-row {
  margin-bottom: 10rem;
}
.avatarClick:hover {
  cursor: pointer;
}
.date {
  display: flex;
  align-items: center;
}
.card {
  cursor: pointer;
}
.card-holding-container, .handover-card-column {
  padding: 2.5px;
}
</style>
